import { render, staticRenderFns } from "./social-post-container.vue?vue&type=template&id=4bafe291&scoped=true&lang=pug"
import script from "./social-post-container.js?vue&type=script&lang=js&external"
export * from "./social-post-container.js?vue&type=script&lang=js&external"
import style0 from "./social-post-container.vue?vue&type=style&index=0&id=4bafe291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafe291",
  null
  
)

export default component.exports